import { Box, Container, Divider, Typography } from '@mui/material';
import { useThemeMode } from '../contexts/ThemeContext';

const Terms = () => {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        py: 8,
        background: isDark
          ? 'linear-gradient(180deg, rgba(11, 17, 32, 0.9) 0%, rgba(17, 24, 39, 1) 100%)'
          : 'linear-gradient(180deg, rgba(248, 250, 252, 1) 0%, rgba(241, 245, 249, 1) 100%)',
      }}
    >
      <Container maxWidth="md">
        <Typography variant="h3" sx={{ fontWeight: 700, color: 'text.primary', mb: 1 }}>
          Terms of Service
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          By using the platform, you agree to follow applicable laws and platform rules.
        </Typography>
        <Divider sx={{ borderColor: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)' }} />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 3, lineHeight: 1.7 }}>
          This page is a short summary for now. For questions, contact info@sebear.it.
        </Typography>
      </Container>
    </Box>
  );
};

export default Terms;
